
export const GET_SUPER_ADMIN_DASHBOARD = 'get_super_admin_dashboard';
export const GET_SUPER_ADMIN_DASHBOARD_SUCCESS = 'get_super_admin_dashboard_success';
